import { DOCUMENT } from '@angular/common';
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';

@Component({
  selector: 'app-generic-end-form',
  templateUrl: './generic-end-form.component.html',
  styleUrls: ['./generic-end-form.component.scss'],
})
export class GenericEndFormComponent {
  @Input() title: string;
  @Input() text: string;
  @Input() linkWhatsapp?: string;
  @Input() subtitle: string;
  @Input() description: string;
  @Input() pathImg?: string;
  @Input() buttonTitle: string;
  @Output() buttonRedirectGo = new EventEmitter();
  @Output() buttonRedirectBack = new EventEmitter();
  document: Document;

  constructor(@Inject(DOCUMENT) dom: Document) {
    this.document = dom;
  }

  // openWhatsapp() {
  //   const number = '+551140044828';
  //   const url = 'https://api.whatsapp.com/send?phone='
  //     .concat(number)
  //     .concat(
  //       '&text=Olá, venho do canal web e gostaria de falar sobre a minha proposta de crédito imobiliário',
  //     );
  //   window.open(url);
  // }
}
